(function() {
  const HISTORY_KEY = 'bruiser_search_history';

  // --- 1. FUNCIÓN MAESTRA PARA ABRIR ---
  function openMegaSearch(e) {
    const overlay = document.getElementById('mega-search-overlay');
    const input = document.getElementById('mega-search-input');
    if (!overlay || !input) return;

    if (e) { e.preventDefault(); e.stopPropagation(); }
    
    if (overlay) {
      overlay.classList.add('is-open'); // BAJA LA PERSIANA
      document.body.style.overflow = 'hidden'; // Bloquea el scroll de la web
      
      if (typeof resetMegaSearch === 'function') resetMegaSearch();

      setTimeout(() => {
        if (input) input.focus();
      }, 400); 
    }
   // overlay.style.setProperty('display', 'block', 'important');
    //input.focus();
    //document.body.style.overflow = 'hidden';
    renderHistory();
  }


  // --- 2. ESCUCHADORES DE CLIC (Apertura y Cierre) ---
  document.addEventListener('click', function(e) {
    const isTrigger = e.target.closest('.lv-mobile-search-trigger') || 
                      e.target.closest('.lv-icon-search-scroll') || 
                      e.target.closest('.hdt-header-col-search') ||
                      e.target.closest('.lv-sticky-search-mini') ||
                      e.target.closest('[href="/search"]');

    if (isTrigger) openMegaSearch(e);

    // Cerrar con la X o tocando fuera
    const overlay = document.getElementById('mega-search-overlay');
    if (e.target.id === 'close-search' || e.target.classList.contains('lv-close-btn') || e.target === overlay) {
      if (overlay) {
        //overlay.style.display = 'none';
        overlay.classList.remove('is-open'); // SUBE LA PERSIANA
        document.body.style.overflow = '';
        // LLAMAMOS AL RESET AQUÍ
        resetMegaSearch();
      }
    } 
    // Si toca cualquier lupa o trigger
    if (e.target.closest('.lv-icon-search-scroll, .lv-trigger-mini, .lv-mini-search-trigger, .hdt-header-col-search')) {
      window.openMegaSearch(e);
    }
  }, true);

  // --- 3. LÓGICA DE BÚSQUEDA (Escritura) ---
  document.addEventListener('input', function(e) {
    if (e.target.id === 'mega-search-input') {
      const query = e.target.value.trim();
      const initialContent = document.getElementById('search-initial-content');
      const resultsArea = document.getElementById('search-results-area');

      if (query.length < 2) {
        if (initialContent) initialContent.style.display = 'block';
        if (resultsArea) resultsArea.style.display = 'none';
        return;
      }

      console.log("🔍 Buscando:", query);

fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=10`)      .then(response => response.json())
      .then(data => {
        const res = data.resources.results;
        
        if (initialContent) initialContent.style.display = 'none';
        if (resultsArea) resultsArea.style.display = 'block';
        
         const cContainer = document.getElementById('predictive-search-collections');
        const prohibidas = ['privada', 'interno', 'test', 'vip', 'pesados'];
        
        // Filtramos las prohibidas
        const todasLasFiltradas = res.collections.filter(c => 
          !prohibidas.some(p => c.title.toLowerCase().includes(p))
        );

        // Tomamos máximo 3 colecciones para dejar espacio a palabras
        const coleccionesFinales = todasLasFiltradas.slice(0, 3);
        
        if (cContainer) {
          cContainer.innerHTML = coleccionesFinales.map(c => `<li><a href="${c.url}">${c.title}</a></li>`).join('');
        }

        // --- 2. PROCESAR SUGERENCIAS (Rellenar hasta llegar a 6 total) ---
        const qContainer = document.getElementById('predictive-search-queries');
        const cupoRestante = 5 - coleccionesFinales.length; // Calculamos cuánto espacio queda
        
        const sugerenciasFinales = res.queries && res.queries.length > 0 
          ? res.queries.slice(0, cupoRestante) 
          : [];

        if (qContainer) {
          if (sugerenciasFinales.length > 0) {
            qContainer.innerHTML = sugerenciasFinales.map(q => `<li><a href="${q.url}">${q.text}</a></li>`).join('');
          } else {
            // Si no hay sugerencias de la API, ponemos al menos la palabra que escribe
            qContainer.innerHTML = `<li><a href="/search?q=${query}">${query}</a></li>`;
          }
        } 

        // --- 3. RENDER PRODUCTOS (RELLENO HASTA 6) ---
        const pContainer = document.getElementById('predictive-search-products');
        if (pContainer) {
          let productosEncontrados = res.products || [];
          
          // Creamos el HTML de los productos que SÍ ha encontrado Shopify
          let htmlResultados = productosEncontrados.slice(0, 6).map(p => `
            <div class="search-item">
              <a href="${p.url}" onclick="saveToHistory('${p.title.replace(/'/g, "\\'")}');" style="text-decoration:none; color:black;">
                <img src="${p.image}" alt="${p.title}">
                <b>${p.title}</b><br><span>${p.price}</span>
              </a>
            </div>`).join('');

          // LÓGICA DE RELLENO: Si hay menos de 6, cogemos de los Destacados
          if (productosEncontrados.length < 6) {
            const destacadosOriginales = document.querySelectorAll('.lv-featured-item');
            const faltan = 6 - productosEncontrados.length;
            
            console.log(`Completando cuadrícula: faltan ${faltan} productos.`);

            for (let i = 0; i < faltan; i++) {
              if (destacadosOriginales[i]) {
                // Clonamos el HTML de los destacados que ya tienes en el Liquid
                htmlResultados += destacadosOriginales[i].outerHTML;
              }
            }
          }

          pContainer.innerHTML = htmlResultados;
        }
      })
      .catch(err => console.error("❌ Error fetch:", err));
    }
  });

  // --- 4. TECLA ENTER ---
  document.addEventListener('keydown', function(e) {
    if (e.target.id === 'mega-search-input' && e.key === 'Enter') {
      const query = e.target.value.trim();
      if(query.length > 0) {
        saveToHistory(query);
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    }
  });

  // --- 5. HISTORIAL ---
  window.saveToHistory = function(term) {
    if (!term || term.length < 2) return;
    let history = JSON.parse(localStorage.getItem(HISTORY_KEY)) || [];
    
    // Filtramos para no duplicar si ya existe
    history = history.filter(h => h.toLowerCase() !== term.toLowerCase());
    
    // Añadimos al principio
    history.unshift(term);
    
    // GUARDAMOS SOLO LOS 3 PRIMEROS
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(0, 3)));
  }

  function renderHistory() {
    const history = JSON.parse(localStorage.getItem(HISTORY_KEY)) || [];
    const historyList = document.getElementById('search-history');
    const historySection = document.getElementById('history-section');
    if (history.length > 0 && historyList) {
      if (historySection) historySection.style.display = 'block';
      historyList.innerHTML = history.map(term => `<li><a href="/search?q=${encodeURIComponent(term)}">🕒 ${term}</a></li>`).join('');
    }
  }

  // --- 6. SCROLL LUPA ---
  window.addEventListener('scroll', function() {
    const stickyLupa = document.getElementById('lv-sticky-lupa');
    if (stickyLupa) {
      if (window.scrollY > 100) stickyLupa.classList.add('is-visible');
      else stickyLupa.classList.remove('is-visible');
    }
  });


 function resetMegaSearch() {
  const input = document.getElementById('mega-search-input');
  const initialContent = document.getElementById('search-initial-content');
  const resultsArea = document.getElementById('search-results-area');

  if (input) {
    input.value = ''; // Borra el texto escrito
  }
  
  if (initialContent && resultsArea) {
    initialContent.style.display = 'block'; // Muestra las recomendaciones/historial
    resultsArea.style.display = 'none';    // Esconde los resultados de la búsqueda anterior
  }
}

})();